import React from 'react';
import { GiBarrier} from 'react-icons/gi';
import { Link } from 'react-router-dom';

const MissionVissionValues = () => {
    return (  
        // <>
        //     <GiBarrier  size={250} style={{marginLeft:"42%"}}/>
        //     <div style={{textAlign:"center"}}>This Page is under Construction.....</div>
        //     <Link to='/admin-login'style={{color:'black', marginLeft:"45%"}}> Admin Login </Link>
        // </>
        <></>
    );
}
 
export default MissionVissionValues;